import { currentMonth, currentYear } from '../util';
import { USER_STATUS_EX_PARTNER, USER_TYPE_REGISTERED } from '../../user';

const getters = {
  isLogged: state => Boolean(state.userId),
  isUserCommentable: state => (commentType) => {
    if ((commentType === 0 || commentType === 1) && state.userType >= 1) {
      return true;
    }

    if ((commentType === 4 || commentType === 5) && state.userType >= 3) {
      return true;
    }

    return false;
  },
  showPartnerHeader: state => state.userType <= USER_TYPE_REGISTERED,
  // ñapa dado que !!state.userType siempre devuelve true (?)
  isPartner: state => !!state.isPartner,
  isExPartner: state => state.status === USER_STATUS_EX_PARTNER,
  userType: state => state.userType,
  userAvatarUrl: state => state.avatarUrl,
  userNick: state => state.nick,
  user: (state, getters) => {
    if (getters.isLogged) {
      return {
        id: state.userId,
        nick: state.nick
      }
    }
    return {};
  },
  contentId: state => state.contentId,
  loginUrl: state => state.loginUrl,
  redirectUrl: state => state.redirectUrl,
  registerUrl: state => state.registerUrl,
  partnerUrl: state => state.partnerUrl,
  increaseQuotaUrl: state => state.increaseQuotaUrl,
  profileUrl: state => state.profileUrl,
  valuatedContents: state => () => {
    const items = localStorage.getItem(`likes_${currentYear}_${currentMonth}`)?.split(',') || [];
    return items.filter(id => !!id).map(id => parseInt(id));
  },
  isValuated: (state, getters) => contentId => getters.valuatedContents().includes(contentId),
  totalValuations: state => state.valuations,
  expiredCard: state => state.tarjetaCaducada,
  gracePeriod: state => state.periodoGracia,
  shoppingCart: state => state.carrito,
};

export default getters;
